import { ioExtend } from '@framework';


export class ErrorModel {
    ErrorCode: string = null;
    ErrorMessage: string = null;
    ErrorDetails: ErrorModel[] = [];
    constructor(_error?: {}) {
        ioExtend(this, _error);
    }
}

export class ErrorLogModel extends ErrorModel {
    ErrorLogID: string = null;
    UserID: string = null;
    Method: string = null;
    Route: string = null;
    Body: string = null;
    DateCreated: Date = null;

    constructor(_errorlog?: {}) {
        super(_errorlog);
        ioExtend(this, _errorlog);
    }
}
